<template>
  <div>
    <the-navigation-bar />
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import MainView from "./views/mainView.vue";
import TheNavigationBar from "@/components/navigation/TheNavigationBar";

export default {
  components: {
    MainView,
    TheNavigationBar,
  },
};
</script>
